export enum ETagsUrls {
  BASE_URL = 'tags',
  WORKSHOP = 'workshop',
  REGISTRANT = 'registrant',
  ORGANIZATION = 'organization',
  PEOPLE = 'people',
  PARENT_ORDER = 'parent-order',
  SUBSCRIBER = 'subscriber',
  EVENT = 'event',
  EVENT_REGISTRANT = 'event-registrant',
  EVENT_EVENT = 'event-event',
}

export const getTagsListUrl = ETagsUrls.BASE_URL;
